export default __webpack_public_path__ + "1cf18ed72aa49dd7249277523853726a.svg";